<template>
  <v-layout column justify-center class="custom-container">
    <v-layout
        justify-center
        align-center
        v-if="folders && folders.length > 0"
        class="list-folders-actions"
    >
      <span>Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount }}</span>
      <v-btn icon @click="pageNumber--" :disabled="pageNumber <= 1">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-btn icon @click="pageNumber++" :disabled="pageNumber >= pages">
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-layout>

    <section class="folders px-4" v-if="!isEmpty(folders)">
      <v-layout
          v-for="folder in folders"
          :key="folder.id"
          column
          class="folder-list"
      >

        <v-layout
            class="item"
            justify-center
            align-center
            @click.stop="openFolder(folder.id)"
            row
        >
          <v-divider vertical/>
          <v-flex class="pa-2" xs4>
            <v-layout class="folder-name" align-center row>
              <img
                  class="folder-icon ma-2"
                  src="/static/images/folder/folder-open-icon.svg"
                  alt="Ícone de Pasta"
              >
              <v-layout column>
                <v-tooltip top>
                  <v-flex class="grey--text" slot="activator">
                    <span class="caption process-number">{{ folder.process_number }}</span>
                  </v-flex>
                  <v-flex class="type-name" slot="activator">
                    <span>{{ folder.folder_type.name }}</span>
                  </v-flex>
                  <span>{{ folder.subject || 'Sem descrição' }}</span>
                </v-tooltip>

              </v-layout>
            </v-layout>
          </v-flex>

          <v-flex class="pa-2" xs3 xl4>
            <v-chip color="grey-lighten-2 entity-chip">
              <v-avatar size="16" color="white">
                <v-icon size="16" color="grey">mdi-briefcase</v-icon>
              </v-avatar>
              <strong class="grey--text text--darken-2 text-truncate">{{ folder.entity.name }}</strong>
            </v-chip>
          </v-flex>

          <v-flex class="pa-2" xs3 xl2>
            <v-layout justify-center>
              <current-owner :folder="folder"/>
            </v-layout>
          </v-flex>

          <v-flex class="pa-2" xs2>
            <v-tooltip top>
              <v-layout slot="activator" align-center>
                <v-icon v-if="!isEmpty(folder.created_at)" size="22" class="mr-2">mdi-clock-fast</v-icon>
                <span class="caption">{{ formatDate(folder.created_at) || '' }}</span>
              </v-layout>
              <span>Criação do Processo</span>
            </v-tooltip>

          </v-flex>
        </v-layout>
        <v-divider/>
      </v-layout>

    </section>

    <!-- Empty Content -->
    <v-layout
        v-if="isEmpty(folders)"
        column
        align-center
        justify-center
        style="height: calc(100vh - 112px)"
    >
      <v-icon class="mb-2" size="48" color="grey darken-2">mdi-inbox</v-icon>
      <span class="title font-weight-regular grey--text text--darken-2">
        Não foram encontrados resultados para sua busca
      </span>
    </v-layout>
  </v-layout>
</template>

<script>
  import { isEmpty } from 'lodash';
  import * as ptLocale from 'date-fns/locale/pt';
  import format from 'date-fns/format';

  import CurrentOwner from '@/components/inbox/CurrentOwner';

  export default {
    name: 'list-all-folders',
    components: { CurrentOwner },
    data() {
      return {
        pageNumber: 1,
        rowsPerPage: 20,
        isEmpty,
      };
    },
    methods: {
      openFolder(id) {
        const route = this.$router.resolve(`/pastas/${id}/show`);
        window.open(route.href, '_blank');
      },
      getFolders() {
        if (this.searchText && this.searchText.length > 2) {
          this.$store.dispatch('setLoadingSearchText', true);
          this.$store.dispatch('getFoldersSearch', {
            page: this.pageNumber,
            limit: this.rowsPerPage,
            searchText: this.searchText || '',
          }).finally(() => {
            this.$store.dispatch('setLoadingSearchText', false);
          });
          this.$store.dispatch('getFoldersCount');
        } else {
          this.$store.dispatch('setLoadingSearchText', false);
        }
      },
      formatDate(date) {
        return format(date, 'DD/MM/YYYY');
      },
      formatMonthYear(date) {
        return format(date, 'MMMM [de] YYYY', { locale: ptLocale });
      },
    },
    computed: {
      folders() {
        if (this.$store.getters.folders.length === undefined) {
          return [];
        }

        const searchFolders = this.$store.getters.folders.filter(
            item => item.folder_section === 'search',
        );
        return searchFolders;
      },
      foldersCount() {
        return this.$store.getters.activeTotalFolders;
      },
      pages() {
        return this.$store.getters.foldersPagesCount;
      },
      pageStart() {
        return (this.pageNumber * this.rowsPerPage) - (this.rowsPerPage - 1);
      },
      pageStop() {
        return Math.min(this.pageStart + (this.rowsPerPage - 1), this.foldersCount);
      },
      searchText() {
        return this.$store.getters.searchText;
      },
    },
    watch: {
      pageNumber: {
        handler: 'getFolders',
        immediate: true,
      },
      searchText: {
        handler: 'getFolders',
      },
    },
  };
</script>

<style scoped lang="scss">
  .custom-container {
    height: calc(100vh - 48px);
    position: relative;
    overflow: hidden;
  }

  .folders {
    overflow-y: auto;
    height: 100%;
    margin-top: 72px;
  }

  .folder-icon {
    max-width: 32px;
  }

  .item {
    cursor: pointer;
  }

  .list-folders-actions {
    position: absolute;
    z-index: 4;
    width: 100%;
    background: white;
    top: 0;
    margin-top: 25px;
  }

  .folder-list {
    &:last-child {
      margin-bottom: 45px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/ListAllFolders.vue